import { LoadingSkeleton } from '../../../Loader/Skeleton';

export const Loader = () => {
  return (
    <div className="body-xl br-4" data-test="category-tile-loader">
      <LoadingSkeleton width="154px" height="44px" />
    </div>
  );
};
